var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecklist = function SvgChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.244 3.244C2 4.49 2 6.494 2 10.5s0 6.01 1.244 7.255C4.49 19 6.494 19 10.5 19s6.01 0 7.255-1.245C19 16.51 19 14.507 19 10.5s0-6.01-1.245-7.256C16.51 2 14.507 2 10.5 2S4.49 2 3.244 3.244M9.262 6.69a.638.638 0 0 0-.924-.878L6.372 7.876l-.51-.535a.637.637 0 1 0-.924.878l.972 1.02a.637.637 0 0 0 .923 0zm2.088.624a.638.638 0 0 0 0 1.275h4.25a.638.638 0 0 0 0-1.275zM9.262 12.64a.639.639 0 1 0-.924-.88l-1.966 2.066-.51-.535a.637.637 0 1 0-.924.878l.972 1.02a.64.64 0 0 0 .923 0zm2.088.622a.638.638 0 0 0 0 1.275h4.25a.638.638 0 0 0 0-1.275z",
    clipRule: "evenodd"
  })));
};
export default SvgChecklist;